import htm from "htm/mini";

// Custom createElement function
function h(
  tag: string,
  props: Record<string, any> | null,
  ...children: any[]
): HTMLElement {
  // Handle tag with id/classes (like 'div#id.class1.class2')
  let element: HTMLElement;

  if (typeof tag === "string") {
    const [tagName, ...classesAndId] = tag.split(/([.#])/g);
    element = document.createElement(tagName || "div");

    // Process classes and id
    if (classesAndId.length) {
      for (let i = 0; i < classesAndId.length; i += 2) {
        const prefix = classesAndId[i];
        const value = classesAndId[i + 1] || "";

        if (prefix === "#") element.id = value;
        else if (prefix === ".") element.classList.add(value);
      }
    }
  } else {
    throw new Error("Only string tags are supported");
  }

  // Add properties/attributes
  if (props) {
    Object.entries(props).forEach(([key, value]) => {
      if (key === "style" && typeof value === "object") {
        Object.assign(element.style, value);
      } else if (key === "className") {
        element.className = value;
      } else if (key.startsWith("on") && typeof value === "function") {
        element.addEventListener(key.substring(2).toLowerCase(), value);
      } else {
        element.setAttribute(key, String(value));
      }
    });
  }

  // Add children
  const addChild = (child: any) => {
    if (child === null || child === undefined || child === false) {
      // Skip
    } else if (Array.isArray(child)) {
      child.forEach(addChild);
    } else if (typeof child === "string" || typeof child === "number") {
      // Always add strings, even empty ones (important for empty table cells)
      element.appendChild(document.createTextNode(String(child)));
    } else if (child instanceof Node) {
      element.appendChild(child);
    } else {
      element.appendChild(document.createTextNode(String(child)));
    }
  };

  children.forEach(addChild);

  return element;
}

// Bind htm to our custom createElement function
export const html = htm.bind(h);
